import React from 'react';
import { V3 } from '../../api_request';
import URLHelpers from '../../shared/url_helpers';

import CalloutEmbed from '../callout_embed';

interface Brand {
  name: string;
  href: string;
  fullBleedHeaderImage: string;
}

interface Props {
  slug: string;
  narrow?: boolean;
}

export default class BrandCalloutEmbed extends React.Component<Props, Brand> {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      href: null,
      fullBleedHeaderImage: null,
    };
  }

  componentDidMount() {
    const req = V3.get(URLHelpers.brandsPath(this.props.slug));

    req.then((response) => {
      this.setState({
        name: response.name,
        href: response._links.web.href,
        fullBleedHeaderImage: response._links.full_bleed_header_image.href,
      });
    });
  }

  render() {
    if (!this.state.href) { return null; }

    return (
      <CalloutEmbed
        title={this.state.name}
        href={this.state.href}
        backgroundImage={this.state.fullBleedHeaderImage}
        narrow={this.props.narrow}
      />
    );
  }
}
